<div class="snackbar-container">
    <mat-icon class="snackbar-icon" [ngClass]="'snackbar-icon--' + tipo()">{{ icono() }}</mat-icon>
    <div>
        <span class="snackbar-message">{{ data.message }}</span>
    </div>
    <button mat-icon-button (click)="close()" class="snackbar-close">
        <mat-icon>close</mat-icon>
    </button>
</div>
